import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import i18n from '@/lang/i18n';
import { ref, computed, watchEffect } from "vue";
import { CVR_UPLOAD_REQUEST_SELECT_RANGE } from "@/services/consts"

type rangeType = {
  start_at: Date;
  end_at: Date;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'SelectRangeSelect',
  props: {
    ranges: {},
    selectedTime: {},
    modelValue: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit

const props = __props;

const selectedTime = computed(() => {
  if (!props.selectedTime) {
    return null;
  }
  return new Date(props.selectedTime);
})

const selectableRange = computed(() => {
  const selectableCount = diffSelectetTimeToEndTime()
  return CVR_UPLOAD_REQUEST_SELECT_RANGE.slice(0, selectableCount)
})

function diffSelectetTimeToEndTime() {
  const range = getSelectedTimeRange()
  if (!range) {
    return 3;
  }

  let selectableMinutes = Math.ceil((range.end_at - selectedTime.value) / 1000 / 60) ;
  if (selectableMinutes > 3) {
    return 3;
  }
  return selectableMinutes;
}

function getSelectedTimeRange() {
  if (!selectedTime.value) {
    return null;
  }

  new Date(selectedTime.value)
  const ranges = props.ranges ?? []
  let range = null
  ranges.forEach((r) => {
    if (selectedTime.value >= r.start_at && selectedTime.value <= r.end_at) {
      range = r;
    }
  })
  return range;
}

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits('update:modelValue', value);
  },
})

watchEffect(() => {
  if (selectableRange.value.indexOf(props.modelValue) < 0) {
    emits('update:modelValue', selectableRange.value.slice(-1)[0]);
  }
})


return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createBlock(_component_v_select, {
    label: _unref(i18n).global.t('pages.cvr_uploads.period'),
    items: selectableRange.value,
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
    clearable: false
  }, null, 8, ["label", "items", "modelValue"]))
}
}

})